// extracted by mini-css-extract-plugin
export default {"like":"Like_like__zCZZW"};